import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app';
import { AppAuth0Provider } from './auth/app_auth0_provider';
import './styles/global.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Application root element was not found.');
}

createRoot(root).render(
  <BrowserRouter>
    <AppAuth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN?.trim() ?? ''}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID?.trim() ?? ''}
      audience={import.meta.env.VITE_AUTH0_AUDIENCE?.trim()}
    >
      <App />
    </AppAuth0Provider>
  </BrowserRouter>
);
